import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import DeviceList from './DeviceList'
import DeviceSummary from './DeviceSummary'
import axios from 'axios'
import {leftArrowTip} from '../../../Templates/icons'
import Modal from "./Modal"
class DeviceManagementPage extends Component {
    signal = axios.CancelToken.source()
    state = {
        openModal: false,
        selectedDevice: null,
        isLoading: true,
        openSimpleModal: false
    }

    componentDidMount = () => {
        this.loadData()
    }

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
        clearTimeout(this.timeout)
    }

    // api requests are made with a AbortController cancel token. When the component unmounts the api request is aborted,
    loadData = () => {
        Promise.all([
            this.props.fetchAllDevices(this.signal.token),
        ]).then(([res1]) => {
            this.setState({ isLoading: false })
        }).catch(err => {
            if (axios.isCancel(err)) {
                console.info('Device Management Page - ', err.message)
            } else {
                console.debug('Error', err.message)
            }
        });
    }

    openSimpleModal = () => {
            // console.log("opening modal")
        this.setState(({ openSimpleModal}) => ({openSimpleModal : !openSimpleModal}));
    }

    closeSimpleModal = () => this.setState({ openSimpleModal: false })

    selectDevice = (id) => {
        let selectedDevice = this.props.devices[id]
        let previouslySelected = selectedDevice === this.state.selectedDevice
        let differentUser = this.state.selectedDevice && this.state.selectedDevice._id !== id
        if (previouslySelected && !differentUser) {
            return this.setState({ selectedDevice: null })
        } else if (differentUser) {
            return this.setState({ selectedDevice: null }, () => this.setState({ selectedDevice }))
        }
        return this.setState({ selectedDevice })
    }

    displaySimplyModal = () => {
        
            return this.state.openSimpleModal ? <Modal
            modalTitle={"New Work Instruction"}
            closeModal={this.closeSimpleModal}
            callingComponent={"Work Instructions Author Mainpage"}
            submitForm={{}}
           />: null

    }

    renderActivityIcon = (status="") => {
        status = status.toLowerCase()
        switch (status) {
            case "online":
                return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em' }}>
                    <ellipse cx="8" cy="8" rx="7.29947" ry="8" fill="#228B22" />
                </svg>
            case "idle":
                return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em' }}>
                    <ellipse cx="8" cy="8" rx="7.29947" ry="8" fill="orange" />
                </svg>

            case "offline":
                return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em'}}>
                    <ellipse cx="8" cy="8" rx="7.29947" ry="8" fill="#cdcdcd" />
                </svg>
            default:
                return null
        }
    }

    render = () => {
        const selectedDevice = this.state.selectedDevice
        return <div className="device-manager-page-window max-width rel" style={{ height: "calc(100% - 47px)" }}>
                    <div id="device-manager-page-content" className={`max-size flex`}>
                        {this.displaySimplyModal}
                        <DeviceList
                            selectedDevice={selectedDevice}
                            devices={Object.values(this.props.devices)}
                            loading={this.state.isLoading}
                            selectDevice={this.selectDevice}
                            renderActivityIcon={this.renderActivityIcon}
                            openModal={this.openSimpleModal}
                            closeModal={this.closeSimpleModal}
                        />

                        {/* renders summary if a work instruction has been selected, else renders directions */}
                        {selectedDevice ?
                            <DeviceSummary 
                                device={selectedDevice} 
                                updateDeviceAuthorization={(value) => {
                                    let device = this.state.selectedDevice;
                                    device.authorized = value;
                                    this.setState({selectedDevice: device})
                                }}
                                renderActivityIcon={this.renderActivityIcon}/>
                            :
                            <div id="device-summary-container" className="flex-column shadow">
                                <div id="directions-panel" className="flex-column-centered max-height">
                                    {this.state.isLoading ? <h3 className="pageTitleFontSize">Device list is loading</h3>
                                        : <div className="flex-centered">
                                            {leftArrowTip}
                                            <h3 className="pageTitleFontSize">Select a device to view/edit information.</h3>
                                        </div>}
                                </div>
                            </div>}
                    </div>
        </div>
    }
}

export default withRouter(DeviceManagementPage)